/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum PlatformType {
  android = "android",
  ios = "ios",
}

export interface ChangePasswordInput {
  newPassword: string;
  oldPassword: string;
}

export interface ConfirmKeysDeliveryInvitationInput {
  invitationId: string;
  eventId: string;
  isAttending: boolean;
}

export interface GetBankSlipNotificationInput {
  billReceivableId: string;
  installmentId: string;
}

export interface ListStatementsInput {
  saleContractId: string;
}

export interface OpenPaymentSlipInput {
  receivableBillId: string;
  installmentId: string;
  newDueDate: any;
}

export interface RecoverPasswordInput {
  cpf: string;
}

export interface RegisterPaymentSlipInput {
  receivableBillId: number;
  installmentId: number;
  correctionDate?: any | null;
}

export interface SignInInput {
  cpf: string;
  password: string;
}

export interface SignInWithRefreshTokenInput {
  refreshToken: string;
}

export interface SignUpInput {
  cpf: string;
  email: string;
}

export interface UpdatePushEndpointInput {
  deviceToken: string;
  platformApplication: PlatformType;
}

export interface UpdateSendNotificationFlagInput {
  sendNotifications: boolean;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
